import { Post } from "../utils/http.js"

// 获取价签数据 - 促销标签、价格、库存
export function getPrice(params) {
  return Post("/api/pricetag/display/calc", params)
}

// 获取优惠券 - 领券功能
export function getPandoraCoupon(params) {
  return Post("/api/dshop/reward", params, {
    loading: true
  })
}
